export default "__VITE_ASSET__644c19ee__"